<template>
  <div class="fzmFillTheBox">
    <div class="innerBox" >
        <template v-if="box">
            <template v-for="(flavor, index) in box.flavors">
                <img 
                :key="index"
                :src="getflavorimage(flavor)" alt="">
            </template>
            
            <template v-for="n in 12 - box.flavors.length">
                <img 
                style="visibility : hidden;"
                :key="n+'filler'"  
                :src="require(`@/assets/img/donut-transparent.png`)" alt="">
            </template>
        </template>
        

    </div>
</div>
</template>

<script>
export default {
    props : {
        /**
         * active box will have default first box open
         */
        activebox : {
            type : Number,
            default: () => {
                return 0;
            }
        }
    },
    computed : {
        /**
         * Get flavors
         */
        flavors() {
            return this.$store.state.flavors
        },
          /**
         * User order box list
         */
        orderboxes() {
            return this.$store.state.orderboxes
        },
        /**
         * Flavors from store
         */
        box() {
            /**
             * Get box data base on active box index
             */
            const box = this.orderboxes;

            return box[this.activebox];
        }
    },
    methods : {
        /**
         * Get flavor image 
         * @param {Number} flavorid
         */
        getflavorimage(flavorid) {
            const flavor = this.flavors.find(f => f.id == flavorid);
            return flavor ? flavor.top_image_url : '';
        }
    }  

}
</script>

<style lang="scss">
.fzmFillTheBox {
    background-image: url('../assets/img/flavorboxesbg.png');
    background-size : cover;
    .innerBox {
        background-color: transparent;
    }
}
</style>